import { Link } from "react-router-dom";
import { Plus } from "lucide-react";
import { toast } from "sonner";
import { useCart } from "@/context/CartContext";
import { GameCover, PlatformBadge } from "@/components/store/GameCover";
import { isOut, money, slug } from "@/lib/api";

export const StockTag = ({ out }) => {
  if (out) return <span className="text-xs text-red-400">Out of stock</span>;
  return <span className="text-xs text-emerald-400/90">In stock</span>;
};

export const GameCard = ({ game, index = 0 }) => {
  const { add, setOpen } = useCart();
  const out = isOut(game);
  const onAdd = () => {
    add(game);
    toast.success(`${game.name} added to cart`, { action: { label: "View cart", onClick: () => setOpen(true) } });
  };
  return (
    <div
      data-testid={`game-card-${slug(game.name)}`}
      className="group rise rounded-lg bg-[#0F1117] border border-white/10 overflow-hidden hover:border-emerald-500/50 hover:shadow-[0_0_24px_rgba(16,185,129,0.15)] transition-[border-color,box-shadow] duration-300"
      style={{ animationDelay: `${Math.min(index, 12) * 40}ms` }}
    >
      <Link to={`/game/${game.id}`} className="block aspect-[460/215] overflow-hidden bg-[#161922]">
        <div className="w-full h-full transition-transform duration-500 group-hover:scale-105"><GameCover game={game} /></div>
      </Link>
      <div className="p-5 space-y-3">
        <div className="flex items-center justify-between">
          <PlatformBadge platform={game.platform} />
          <StockTag out={out} />
        </div>
        <Link to={`/game/${game.id}`} className="block font-semibold leading-snug hover:text-emerald-400 transition-colors line-clamp-1">{game.name}</Link>
        <div className="flex items-center justify-between pt-1">
          <span className="font-mono font-bold text-lg">{money(game.price)}</span>
          <button
            data-testid={`add-to-cart-${slug(game.name)}`}
            disabled={out}
            onClick={onAdd}
            className="inline-flex items-center gap-1 h-10 sm:h-9 px-3 rounded-md bg-white/5 border border-white/10 text-sm font-semibold hover:bg-emerald-500 hover:text-[#08090C] hover:border-emerald-500 disabled:opacity-40 disabled:pointer-events-none transition-colors"
          >
            <Plus size={14} /> Add
          </button>
        </div>
      </div>
    </div>
  );
};
